import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-poconfirm-popup',
  templateUrl: './poconfirm-popup.component.html',
  styleUrls: ['./poconfirm-popup.component.scss']
})
export class PoconfirmPopupComponent implements OnInit {
  @Input() responseData: any;

  displayedColumns: string[] = ['EBELN', 'EBELP', 'REMARK', 'UPLOAD'];

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit(): void {
    console.log('Received data:', this.responseData);
  }

  onModalClose(): void {
    this.bsModalRef.hide();
  }

}
